module.exports = __webpack_public_path__ + "media/assets/images/category/Weddings@2x-17cd774d4a93e5f8c41cebe40404a443.png";